import { Box, Grid, useTheme } from "@mui/material";
import { FooterMenu } from "./menu.js";
import { SocialMediaMenu } from "./social-media-menu";
import { useMediaQuery } from "../utilities/index.js";
import React from "react";
export const FooterMenus = ({ headingComponent = "h5", menus = [], socialMedia, }) => {
    const theme = useTheme();
    const useThreeColumns = useMediaQuery(theme.breakpoints.only("sm"));
    if (menus.length === 0 && !socialMedia)
        return null;
    const size = Math.floor(12 / (menus.length + (useThreeColumns ? 0 : 1)));
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, direction: "row", spacing: { xs: 4, md: 5, lg: 6 } },
            menus.map((m) => (React.createElement(Grid, { key: `footer-menu-${m.title}`, item: true, xs: 12, sm: size },
                React.createElement(FooterMenu, { ...m, headingComponent: headingComponent })))),
            !useThreeColumns && !!socialMedia && (React.createElement(Grid, { key: `footer-menu-${socialMedia.title}`, item: true, xs: 12, sm: size },
                React.createElement(SocialMediaMenu, { ...socialMedia, headingComponent: headingComponent })))),
        !!socialMedia && useThreeColumns && (React.createElement(Box, { sx: {
                pt: { xs: 4, sm: 6, md: 8, lg: 12 },
                textAlign: "center",
                maxWidth: "70ch",
                margin: "0 auto",
            } },
            React.createElement(SocialMediaMenu, { ...socialMedia, headingComponent: headingComponent })))));
};
//# sourceMappingURL=menus.js.map